import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import AdditionalDocumentsDropZone from 'components/AdditionalDocumentsDropZone/styled';

const enhance = compose(withTranslation('AdditionalDocuments'));

export default enhance(AdditionalDocumentsDropZone);
